export const blockIconsActivitiesSportsMartialArtsNew = (
	<span className='material-symbols-outlined'>sports_martial_arts</span>
);
